import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useSelector from 'hooks/useSelector';
import { userHasPermission } from 'hooks/useRoles';

import {
    myForm,
    shiftSummaryDashboard,
    shiftSummaryDashboardPending,
    shiftSummaryDashboardToAction,
    shiftSummaryDashboardToRevisit,
    shiftSummaryDashboardCompleted,
    shiftSummaryDashboardOverview,
    fatigueAssessmentForm,
    fatigueAssessmentOnBehalf,
    fatigueAssessmentAssign
} from "./FatigueAssessmentPageSelector";

import {
    ChevronRight as RightIcon,
    ExpandMore as DownIcon
} from '@mui/icons-material';

import { ReactComponent as FatigueAssessmentIcon } from "assets/icons/fatigue-assessment-filled.svg";
import './FatigueAssessments.css'
import { ISelectOption } from '../forms/util';


interface FatigueAssessmentSidebarProps {
    selectedPage: ISelectOption
}

export const FatigueAssessmentSidebar = (props: FatigueAssessmentSidebarProps) => {
    const [currentSelection, setCurrentSelection] = useState(props.selectedPage);
    const profile = useSelector(state => state.profile);

    useEffect(() => {
        if (currentSelection === undefined) {
            setCurrentSelection(myForm);
        }
    }, [profile]);

    return (
        <>
            <div className="fa-sidebar fa-sidebar-nav">
                <div className="fa-sidebar-title">
                    <FatigueAssessmentIcon />
                    <div className="d-inline-block">Fatigue Assessment</div>
                </div>

                <div className="fa-sidebar-item">
                    <Link
                        to={myForm.getRoute().path as string}
                        className={`${ currentSelection == myForm ? 'fa-nav-selected' : '' }`}>
                        <div className="row">
                            <div className="col-11">{myForm.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                <div className="fa-sidebar-item">
                    <Link
                        to={fatigueAssessmentForm.getRoute().path as string}
                        className={`${ currentSelection == fatigueAssessmentForm ? 'fa-nav-selected' : '' }`}>
                        <div className="row">
                            <div className="col-11">{fatigueAssessmentForm.label}</div>
                            <div className="col-1"><RightIcon /></div>
                        </div>
                    </Link>
                </div>

                {profile && userHasPermission("web.admin.fatigue-assessment.on-behalf", profile?.roles) &&
                    <div className="fa-sidebar-item">
                        <Link
                            to={fatigueAssessmentOnBehalf.getRoute().path as string}
                            className={`${ currentSelection == fatigueAssessmentOnBehalf ? 'fa-nav-selected' : '' }`}>
                            <div className="row">
                                <div className="col-11">{fatigueAssessmentOnBehalf.label}</div>
                                <div className="col-1"><RightIcon /></div>
                            </div>
                        </Link>
                    </div>
                }

                {profile && userHasPermission("web.admin.fatigue-assessment.shift-summary-dashboard", profile?.roles) &&
                    <>

                        <div className="fa-sidebar-item">
                            <Link
                                to={fatigueAssessmentAssign.getRoute().path as string}
                                className={`${ currentSelection == fatigueAssessmentAssign ? 'fa-nav-selected' : '' }`}>
                                <div className="row">
                                    <div className="col-11">{fatigueAssessmentAssign.label}</div>
                                    <div className="col-1"><RightIcon /></div>
                                </div>
                            </Link>
                        </div>

                        <div className="fa-sidebar-item">
                            <Link
                                to={shiftSummaryDashboard.getRoute().path as string}
                                className={`${ currentSelection == shiftSummaryDashboard || currentSelection.subitem ? 'fa-nav-selected' : '' }`}>
                                <div className="row">
                                    <div className="col-11">{shiftSummaryDashboard.label}</div>
                                    <div className="col-1"><DownIcon className="fa-nav-display-unselected" /></div>
                                </div>
                            </Link>
                        </div>

                        {currentSelection.subitem &&
                            <>
                                <div className="fa-sidebar-item fa-sidebar-subitem">
                                    <Link
                                        to={shiftSummaryDashboardOverview.getRoute().path as string}
                                        className={`${ currentSelection == shiftSummaryDashboardOverview ? 'fa-nav-selected ' : '' }fa-nav-subitem`}>
                                        <div className="row">
                                            <div className="col-11">{shiftSummaryDashboardOverview.label}</div>
                                            <div className="col-1"><RightIcon /></div>
                                        </div>
                                    </Link>
                                </div>


                                <div className="fa-sidebar-item fa-sidebar-subitem">
                                    <Link
                                        to={shiftSummaryDashboardPending.getRoute().path as string}
                                        className={`${ currentSelection == shiftSummaryDashboardPending ? 'fa-nav-selected ' : '' }fa-nav-subitem`}>
                                        <div className="row">
                                            <div className="col-11">{shiftSummaryDashboardPending.label}</div>
                                            <div className="col-1"><RightIcon /></div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="fa-sidebar-item fa-sidebar-subitem">
                                    <Link
                                        to={shiftSummaryDashboardToAction.getRoute().path as string}
                                        className={`${ currentSelection == shiftSummaryDashboardToAction ? 'fa-nav-selected ' : '' }fa-nav-subitem`}>
                                        <div className="row">
                                            <div className="col-11">{shiftSummaryDashboardToAction.label}</div>
                                            <div className="col-1"><RightIcon /></div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="fa-sidebar-item fa-sidebar-subitem">
                                    <Link
                                        to={shiftSummaryDashboardToRevisit.getRoute().path as string}
                                        className={`${ currentSelection == shiftSummaryDashboardToRevisit ? 'fa-nav-selected ' : '' }fa-nav-subitem`}>
                                        <div className="row">
                                            <div className="col-11">{shiftSummaryDashboardToRevisit.label}</div>
                                            <div className="col-1"><RightIcon /></div>
                                        </div>
                                    </Link>
                                </div>

                                <div className="fa-sidebar-item fa-sidebar-subitem">
                                    <Link
                                        to={shiftSummaryDashboardCompleted.getRoute().path as string}
                                        className={`${ currentSelection == shiftSummaryDashboardCompleted ? 'fa-nav-selected ' : '' }fa-nav-subitem`}>
                                        <div className="row">
                                            <div className="col-11">{shiftSummaryDashboardCompleted.label}</div>
                                            <div className="col-1"><RightIcon /></div>
                                        </div>
                                    </Link>
                                </div>
                            </>
                        }
                    </>
                }
            </div>

            {profile && userHasPermission("web.admin.fatigue-assessment.shift-summary-dashboard", profile?.roles) &&
                <div className="fa-sidebar fa-sidebar-links">
                    <div className="fa-sidebar-title">Links</div>
                    <ul>
                        <li><Link to="/reporting/fatigue-assessment">Fatigue Assessment reporting</Link></li>
                    </ul>
                </div>
            }

        </>
    );
}
